<template>
    <div>
        <v-dialog 
            :value="value"
            @input="toggleModal"
            persistent
            width="1100px"
        >
            <v-card>
                <v-toolbar color="secondary" flat dense dark class="modal-terms-toolbar">
                    <v-toolbar-title>
                        <span class="title-modal">
                            Términos y condiciones y política de datos personales
                        </span>
                    </v-toolbar-title>
                    <!-- <v-spacer v-if="!isLoggedIn" /> -->
                    <v-icon class="btn-terms-modal" v-if="!isLoggedIn" @click="toggleModal(false)">mdi-close</v-icon>
                </v-toolbar>
                <v-card-text id="container-modal-body" class="container-modal-body" @scroll="(e)=> handleScroll(e)">
                    <v-row>
                        <v-col cols="12" class="mt-5">
                            <div v-html="termsText"></div>
                            <v-row justify="end">
                                <v-btn
                                    class="btn-terms"
                                    color="primary"
                                    :disabled="acceptTerms"
                                    @click="acceptTerms = true"
                                    rounded
                                    >
                                    acepto
                                </v-btn>
                            </v-row>
                            <div v-if="acceptTerms" v-html="dataTreatmentText"></div>
                        </v-col>
                    </v-row>
                </v-card-text>
        
                <v-card-actions justify="end" class="card-actions-modal">
                    <v-spacer></v-spacer>
                    <v-btn 
                        class="btn-controlls"
                        text
                        color="primary"
                        @click="DeclineAllPolices"
                        :disabled="!endScroll"
                        rounded
                    >
                        No acepto
                    </v-btn>
                    <v-btn 
                        class="btn-controlls"
                        text
                        color="primary"
                        @click="AcceptAllPolices"
                        :disabled="!endScroll"
                        rounded
                    >
                        Acepto
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog 
            :value="showNoAcceptance"
            @input="closeNoAcceptance"
            content-class="border-rounded"
            max-width="430px"
        >
            <v-card>
                <v-toolbar class="toolbar-no-acceptance-modal" color="secondary" flat dense dark>
                    <v-toolbar-title>
                        <span class="title-no-acceptance-modal">
                            Alerta
                        </span>
                    </v-toolbar-title>
                    <v-icon color="secondary" class="btn-close-noacceptance" size="35" @click="closeNoAcceptance">mdi-close-circle-outline</v-icon>
                </v-toolbar>
                <v-card-text class="no-acceptance-text">
                    <v-row class="mt-3">
                        {{ noAcceptanceText }}
                    </v-row>
                    <v-row class="mt-4" justify="center">
                        <v-btn
                            color="primary"                            
                            rounded
                            @click="closeNoAcceptance"
                        >
                            Aceptar
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import { post } from "@/services/apiService";
  import moment from "moment";

  export default {
    computed:{
        ...mapState({
            isLoggedIn: (state) => state.auth.isLoggedIn,
            user: (state) => state.userProfile.userProfile,
        })
    },
    created() {
        if (/Windows/.test(this.userAgent)) {
            this.operativeSistem = 'Windows';
        } else if (/Macintosh|Mac OS/.test(this.userAgent)) {
            this.operativeSistem = 'MacOS';
        } else if (/Android/.test(this.userAgent)) {
            this.operativeSistem = 'Android';
        } else if (/iOS/.test(this.userAgent)) {
            this.operativeSistem = 'iOS';
        } else if (/Linux/.test(this.userAgent)) {
            this.operativeSistem = 'Linux';
        }
    },
    data: () => ({
        termsText:`
            <span>Al acceder a este sitio, el usuario acepta las siguientes condiciones y políticas de uso.</span>
            </br></br>
            <span>FALKON es una marca de propiedad de la sociedad TCC S.A.S.</span>
            </br></br>
            <span>Los presentes Términos y Condiciones regulan la autorización de uso que otorga FALKON a los Usuarios para que éstos ingresen se informen sobre los productos y servicios exhibidos, 
                ofrecidos y comercializados por los Aliados Comerciales, y puedan adquirir los mismos a través de la presente página.</span>
            </br></br>
            <span>El Usuario, al momento de registrarse en la página web y hacer uso de ella, voluntariamente acepta de manera previa, 
                expresa e informada el contenido de los presentes Términos y Condiciones en su totalidad, por lo cual, se obliga irrevocablemente a éstos.</span>
            </br></br>
            <span>La persona natural que acepta los presentes Términos y Condiciones declara y garantiza ser el Usuario que hará uso de la página web.</span>
            </br></br>
            <span>FALKON es plataforma virtual, por medio de la cual se pueden conectar: (i) los Aliados Comerciales; (ii) los Usuarios. 
                Así, a través de esta, los Aliados Comerciales pueden exhibir sus servicios, con el fin de que sean adquiridos por los Usuarios.</span>
            </br></br>
            <span>Es importante aclarar que FALKON no comercializa productos y/o servicios ni presta servicios de logística y/o entrega a los Usuarios. 
                Los precios, cantidad, disponibilidad y características de los productos y/o servicios exhibidos en la Plataforma son determinados directamente por los 
                Aliados Comerciales y no por FALKON.</span>
            </br></br>
            <span>Los Usuarios reconocen y aceptan que FALKON es un portal de contacto y, como tal, no es quien exhibe, 
                ofrece y/o comercializa los productos y/o servicios. En consecuencia, los Usuarios reconocen y aceptan que FALKON no es responsable por la calidad, 
                precio, estado e integridad de los productos y/o servicios de los Aliados Comerciales.</span>
            </br></br>
            <span>El Aliado Comercial, al ser quien exhibe, ofrece y comercializa los productos y/o servicios a través de la Plataforma, 
                es el único responsable de:</span>
            </br></br>
            <ul>
                <li><span>Cumplir a cabalidad las normas relativas que le sean aplicables a sus servicios</span></li></br>
                <li><span>Contar con los permisos y licencias de las autoridades competentes para exhibir, 
                    ofrecer, y comercializar los productos servicios a través de la Plataforma</span></li></br>
                <li><span>Cumplir con todas aquellas normas relativas a la comercialización de productos y servicios, 
                    incluyendo sin limitación la Ley 1480 de 2011.</span></li></br>
            </ul></br></br>
            <span>En virtud de la aceptación de los presentes Términos y Condiciones, 
                    el Usuario se obliga a:</span></br></br>
            <ul>
                <li><span>Ingresar sus Datos Personales de manera veraz al momento de registrarse</span></li></br>
                <li><span>Abstenerse de transferir a terceros los datos de validación de su cuenta</span></li></br>
                <li><span>Notificar a FALKON respecto de cualquier uso no autorizado de su cuenta</span></li></br>
                <li><span>Abstenerse de utilizar la Plataforma para realizar actos contrarios a la moral, la ley, 
                    el orden público, y las buenas costumbres</span></li></br>
                <li><span>Abstenerse de suplantar la identidad de otros Usuarios</span></li></br>
                <li><span>Al solicitar el servicio, el Usuario acepta de manera irrevocable 
                    los costos (valor de los productos, valor del domicilio, tarifa de servicio, entre otros),</span></li></br>
                <li><span>Ante el incumplimiento de cualquiera de las obligaciones contenidas en la presente sección, 
                    FALKON se reserva el derecho de bloquear definitivamente la cuenta del Usuario.</span></li></br>
            </ul>
            <span><strong>Indemnidad:</strong> Sin perjuicio de lo dispuesto en estos términos y condiciones, 
                la indemnidad pactada a favor de TCC comprende las obligaciones de recomposición patrimonial y 
                de defensa judicial y administrativa. Para tal efecto, el Cliente declara que:</span></br></br>
            <ul>
                <li><span>
                Dejará indemne a TCC, a sus empleados o cualquier tercero, cuando hayan padecido algún daño como consecuencia
                de la acción u omisión del Cliente. El Cliente responderá integralmente por esos daños tanto si provienen de una
                culpa contractual suya o del incumplimiento de sus obligaciones. Por esta obligación de indemnidad el Cliente queda
                obligado a responder por todo daño que le cause a TCC, a sus empleados o a cualquier tercero.</span></li></br>
            </ul>
            </br>
            <span><strong>Exclusión de Responsabilidad:</strong> El Cliente es considerado responsable por cualquier daño, 
                perjuicio o lesión, que cause al consumidor final, por incumplimiento de sus obligaciones, tanto las contenidas
                 en estos términos y condiciones, como las que establezca la ley.</span></br></br>
            
            <span><strong>Confidencialidad:</strong> El término información confidencial incluirá: cualquier información comercial, 
                administrativa, técnica, financiera, contable, legal o de cualquier otra actividad pasada, presente y futura, que haya 
                sido o sea suministrada a través de cualquier medio, antes o después de la fecha de aceptación de estos términos y condiciones. 
                El Cliente, sus empleados, contratistas, contratantes, consultores o analistas, entre otros, se abstendrán de divulgar, publicar, 
                reproducir, compartir, transferir, propagar, transmitir, contar, distribuir, conservar y comunicar a terceros, la información definida 
                como confidencial en la presente cláusula.</span></br></br>
            <span>Parágrafo Único: Las disposiciones contenidas en esta cláusula subsistirán por un término de duración de diez (10) años a partir de 
                la fecha de terminación del presente documento. Para estos efectos, el Cliente acepta que el incumplimiento de lo señalado 
                anteriormente ocasiona una lesión a los intereses de TCC.</span></br></br>

            <span><strong>Protección De Datos Personales:</strong> LAS PARTES se comprometen al cumplimiento de la ley Estatutaria 1581 de 2012 
                y a sus decretos reglamentarios 1377 de 2013 y 886 de 2014, de protección de datos personales, a todos aquellos 
                datos recolectados con ocasión al desarrollo del contrato, se convierten en responsables del tratamiento, 
                comprometiéndose a las siguientes obligaciones:</span></br></br>
            <ul>
                <li><span>Garantizar el titular, en todo tiempo, el pleno y efectivo ejercicio del derecho de habeas data.</span></li></br>
                <li><span>Conservar la información bajo las condiciones de seguridad necesarias para impedir su adulteración, perdida, consulta, uso o acceso no autorizado o fraudulento.</span></li></br>
                <li><span>Respetar las condiciones de seguridad y privacidad de la información del titular.</span></li></br>
                <li><span>Tramitar las consultas y reclamos formulados en los términos señalados por la ley.</span></li></br>
                <li><span>Permitir el acceso a la información únicamente a las personas que pueden tener acceso a ella.</span></li></br>
                <li><span>Transmitir los datos personales fuera del país a terceros con los cuales la Parte Responsable del tratamiento 
                    haya suscrito un contrato de procesamiento de datos y sea necesario entregársela para el cumplimiento del objeto contractual.</span></li></br>
                <li><span>Transferir y transmitir los datos personales a terceros encargados nacionales o internacionales con 
                    quienes tenga relación operativa que provea los servicios necesarios para la debida operación de la empresa 
                    Responsable del Tratamiento, o de conformidad con las funciones establecidas a su cargo en las leyes. En dichos supuestos, 
                    se adoptarán las medidas necesarias para que las personas que tengan acceso a sus datos personales cumplan con los principios 
                    de protección de datos personales y obligaciones establecidas en la Ley. En todo caso, cuando la Parte Responsable del Tratamiento 
                    transmita los datos a uno o varios encargados ubicados dentro o fuera del territorio de la República de Colombia, establecerá cláusulas 
                    contractuales o celebrará un contrato de transmisión de datos personales en el que indicará: 1. Alcances del tratamiento, 
                    2. Las actividades que el encargado realizará por cuenta del responsable para el tratamiento de los datos personales y, 
                    3. Las obligaciones del Encargado para con el titular y el responsable.</span></li></br>
            </ul>
            <span>Usar los datos personales del titular solo en desarrollo de las finalidades para las que se encuentre facultado debidamente y 
                respetando en todo caso la normatividad vigente sobre protección de datos personales. Se prohíbe dar a conocer y/o transferir los 
                datos personales proporcionados dentro o fuera del país, a cualquier empresa o terceros, salvo los casos mencionados en los numerales 
                6 y 7 de esta cláusula.</span></br></br>

            <span><strong>LA/FT/FPADM:</strong> En cumplimiento del deber legal que le asiste a TCC en relación con la cooperación de la prevención 
                y control sobre el lavado de activos, financiación del terrorismo y cualquier otro delito de similar categoría contemplado 
                en normas nacionales e internacionales, El Cliente se obliga a: i) Cumplir con las normas colombianas e internacionales vigentes 
                en materia de prevención e identificación de operaciones con recursos de procedencia ilícita, prevención de lavado de lavado de dinero y 
                financiamiento al terrorismo, cohecho, anticorrupción, y cualquier otra legislación que le resulte aplicable; ii) Implementar los mecanismos 
                tendientes a prevenir e identificar operaciones con recursos de procedencia ilícita; y iii) En general abstenerse a realizar cualquier 
                conducta que sea considerada, pueda ser considerada o que exista la sospecha de que sea relacionada a operaciones con recursos de 
                procedencia ilícita.</span></br></br>
            <span>El Cliente declara que su patrimonio, bienes o elementos con los que ejecuta la presente relación contractual y las fuentes económicas 
                que permiten desarrollar su objeto social no son fruto de actividades ilícitas, tales como narcotráfico, testaferrato, enriquecimiento ilícito, terrorismo, 
                lavado de activos, tráfico de estupefacientes, secuestro extorsivo y/o trata de personas, entre otras, razón por la cual acepta que en el evento en que 
                esta o alguno de sus socios o accionistas, empleados, administradores y/o representantes legales, hagan parte de cualquier lista vinculante o restrictiva, 
                de carácter nacional o internacional, o haya sido sentenciado judicialmente por cualquier delito, será responsable por los daños y perjuicios que dicho 
                reporte o sentencia le ocasione a TCC, sin perjuicio de la responsabilidad penal que le asiste y, faculta a TCC, para dar por terminado 
                unilateralmente el presente Contrato en cualquier momento y sin previo aviso, por configurarse una causal objetiva de terminación del mismo.</span></br></br>

            <span><strong>Declaración De Origen De Fondos:</strong> El Cliente declara que los recursos que conforman el patrimonio de la empresa no provienen de ninguna 
                actividad ilícita de las contempladas en el Código Penal Colombiano o en cualquier otra norma que lo modifique, aclare o adicione. En todo momento, 
                El Cliente dará cumplimiento a las disposiciones y políticas de LA/FT/FPADM, con el fin de prevenir y evitar cualquier situación relacionada con el 
                lavado de activos, captación ilegal, y demás actividades prohibidas en materia económica y de servicios financieros.</span></br></br>

            <span><strong>Anticorrupción:</strong> TCC sólo contratará con quienes mantengan los más altos estándares de honestidad, ética y profesionalismo en la 
                gestión de sus negocios. En tal sentido, TCC podrá investigar cualquier indicio, denuncia, sugerencia o evidencia que pudiera llevar a suponer que El 
                Cliente esté involucrado en prácticas prohibidas o indebidas de corrupción y soborno transnacional. El Cliente se obliga a asegurar que él, sus respectivos 
                empleados, subsidiarias, filiales, subcontratistas y proveedores no ofrezcan, prometan o den, en relación con el cumplimiento de las obligaciones o 
                ejecución del Contrato, cualquier cosa de valor, ya sea directa o indirectamente a través de intermediarios, a un tercero o un Funcionario Público, con el 
                fin de obtener o conservar un negocio o recibir un trato más favorable de cualquier tipo de Funcionario Público.</span></br></br>

            <span>Para dar cumplimiento a lo acá pactado se entenderán como “Normas Anticorrupción” todas las leyes y normas jurídicas sobre prohibición de prácticas 
                corruptas y pagos a funcionarios públicos pero sin limitarse, de: i) La República de Colombia; ii) El País de constitución de TCC y de su casa matriz 
                (o su centro principal de actividad); iii)La Ley de Prácticas Corruptas en el Extranjero (Estados Unidos de América), conocida por sus siglas en 
                inglés como “FCPA”;  iv) La Convención para Combatir el Cohecho de Servidores Públicos Extranjeros en Transacciones Comerciales Internacionales, 
                firmada en París el 17 de diciembre de 1997, que entró en vigor el 15 de febrero de 1999, y los Comentarios de la Convención, documento realizado 
                por la OECD (The Organisation for Economic Co-operation and Development); v) Las política de LA/FT/FPADM de TCC, vi) El Código Conducta y el Programa de 
                Transparencia y Ética Empresarial de TCC.</span></br></br>

            <span>El cliente declara y acepta que: (i) Con la aceptación de estos términos y condiciones, se adhiere, conoce, acepta, y se compromete a cumplir el 
                Código de Conducta y el Manual de políticas para SAGRILAFT y/o SIPLAFT asociado a la Prevención del Lavado de Activos, Financiamiento del Terrorismo y 
                Financiamiento de la proliferación de Armas de Destrucción Masiva, así como, el Programa de Transparencia y Ética Empresarial asociado a la Corrupción y 
                Soborno Transnacional. (ii) El derecho o la posibilidad de terminar anticipadamente la relación contractual sin lugar a pago de indemnización alguna 
                en los eventos en que El Cliente o tercero, incumpla las normas vigentes y que sean aplicables en materia de anticorrupción, así como en los eventos en 
                que El Cliente o tercero en relaciones de negocios sean investigados, condenados o incluidos en listas restrictivas nacionales o internacionales por 
                acciones u omisiones relacionadas con incumplimiento de normas vigentes y aplicables en materia de anticorrupción; y que la terminación, rescisión o 
                resciliación unilateral no genere para la compañía obligaciones de carácter indemnizatorio ante el ejercicio de ese derecho. (iii) El Cliente queda 
                obligado a proporcionar la información solicitada por TCC y colaborar con cualquier investigación al respecto.</span></br></br>

            <span>PARÁGRAFO: Cada una de las Partes declara a la otra que ni ellos ni sus subcontratistas o sus correspondientes directores, funcionarios, agentes o 
                empleados ha dado o prometido dar ningún pago, bonificación, comisión u otro pago de dinero y que no dará ni prometerá dar los mismos, y que ni dicha 
                Parte ni aquéllos relacionados con la misma han hecho o prometido hacer ningún regalo de valor significativo a ninguna persona que mantiene un cargo 
                legislativo, ejecutivo judicial, u de otra rama del poder incluyendo a cualquier persona empleada por o actuando en representación de un órgano estatal, empresa 
                estatal o de una organización pública internacional, o ningún partido político o funcionario de un partido o candidato político, o de cualquier otra manera 
                definido como “Funcionario Público” según las Normas Anticorrupción aplicables, y que no efectuarán ni prometerán hacer los mismos con el objeto de obtener o 
                retener negocios para cualquiera de las Partes contratantes o a nombre de las mismas.</span></br></br>

            <span><strong>Declaraciones varias:</strong></span></br></br>
            <ul>
                <li><span>Ninguna de las partes será responsable ante la otra por incumplimiento o retraso en el cumplimiento de sus obligaciones en virtud 
                    de estos términos y condiciones cuando dicho incumplimiento o retraso se deba a cualquier causa fuera del control de la parte interesada, 
                    incluidos casos fortuitos, órdenes o restricciones gubernamentales, incendios, o inundación, siempre que, al cesar tales eventos, dicha parte 
                    cumpliera o completará prontamente el cumplimiento de sus obligaciones en virtud del presente acuerdo</span></li></br>
                <li><span>Los términos y condiciones serán vinculantes para las partes y todos los sucesores de lo anterior que tomen sus derechos en virtud del servicio 
                    adquirido. Salvo que se establezca expresamente en este documento, ninguna de las partes cederá, transferirá o delegará sus derechos u obligaciones 
                    en virtud del servicio adquirido (en su totalidad o en parte) sin el consentimiento previo por escrito de la otra parte.</span></li></br>
                <li><span>TCC, puede utilizar subcontratistas en la ejecución de los Servicios, siempre que TCC, siga siendo responsable del cumplimiento del servicio por parte de dicho subcontratista.</span></li></br>
                <li><span>Este acuerdo se regirá por las leyes de Colombia. El lugar y jurisdicción exclusivos para todas y cada una de eventuales 
                    soluciones judiciales o extrajudiciales por la ejecución, nulidad, interpretación, cláusula resolutoria y/o cualquier conflicto entre las partes, 
                    será resuelto por las autoridades judiciales, administrativas o particulares con funciones jurisdiccionales de Colombia.</span></li></br>
                <li><span>En el caso de que alguna disposición de este acuerdo entre en conflicto con la ley vigente, o si alguna disposición se considera nula, ineficaz, 
                    o inválida por autoridad jurisdiccional competente, se tendrá en cuenta lo siguiente: (a) dicha disposición se considerará reformulada para reflejar como 
                    lo más cerca posible de las intenciones originales de las partes del acuerdo con la ley aplicable, y (b) los términos, disposiciones, convenios y restricciones 
                    restantes de este acuerdo permanecerán en pleno vigor y efecto.</span></li></br>
            </ul>

            <span><strong>Modificaciones:</strong> TCC podrá modificar autónomamente y en cualquier momento aspectos formales, procedimentales o sustanciales de los presentes Términos y Condiciones, los cuales serán actualizados y puestos a disposición de los Clientes.</span></br></br>
        `,
        dataTreatmentText:`
            </br></br>
            <h2><span style="color: #ffa141;"><b>Aviso de privacidad y autorización de tratamiento de datos personales.</b></span></h2></br>
            <span>Al diligenciar este formulario, TCC S.A.S., sociedad con Nit. 860.016.640-4 quien hace parte del Grupo Logístico TCC, en condición de responsable del tratamiento de datos, informa a las personas que mediante el diligenciamiento de este formulario suministran y/o registran sus datos personales que estos serán recolectados, almacenados, procesados, entre otros tratamientos legítimos para las siguientes finalidades:</span>
            <span></span></br></br>
            <ul>
                <li><span>Efectuar las gestiones pertinentes para el desarrollo de la etapa precontractual, 
                    contractual, y pos contractual con alguna (s) de las sociedades del Grupo Logístico TCC y terceros que contraten con él, en desarrollo de los servicios 
                    ofrecidos y/ o adquiridos, o en desarrollo de cualquier relación comercial que tengan.</span></li></br>
                <li><span>Para fines comerciales, de atención al cliente, mercadeo, investigación, acreditación, 
                    actualización; es decir, para todas aquellas actividades asociadas a la relación comercial o vinculo existente con el Grupo Logístico TCC o terceros que 
                    contraten con él.</span></li></br>
                <li><span>Gestionar tramites (solicitudes, quejas, reclamos) a través de los canales 
                    dispuestos por el Grupo Logístico TCC en su página web <a href="https://falkon.com.co/contactanos/" target="_blank">https://falkon.com.co/contactanos/</a> para la atención al público o en el 
                    correo </span><a href="mailto:contabilidad@tcc.com.co"><span>contabilidad@tcc.com.co</span></a><span>.</span></li></br>
                <li><span>Cumplimiento de obligaciones relacionadas con la ejecución del objeto social de las 
                    sociedades del Grupo Logístico TCC, dentro y fuera del territorio nacional.</span></li></br>
                <li><span>Dar a conocer, transferir y/o transmitir mis datos personales dentro y fuera del país, 
                    a cualquier empresa o terceros como consecuencia de un contrato, ley o vínculo licito que así lo requiera para el cumplimiento de sus finalidades.</span></li></br>
                <li><span>Crear bases de datos para los fines descritos en la política de tratamiento de datos.</span></li></br>
                <li><span>Envío de información por cualquier medio conocido o por conocer (correo electrónico, 
                    físico, sms, llamadas telefónicas, etc.) para la remisión de información relacionada con actividades, eventos, programas y servicios que promociona.</span></li></br>
                <li><span>Para fines de seguridad, registro y control 
                    de las personas que acceden a sus instalaciones.</span></li></br>
            </ul>
            </br>
            <span>Así mismo, cumpliendo las normas vigentes, se informa que los datos personales podrán ser tratados directamente y/o a través de terceros, 
                en condición de encargados del tratamiento de datos, en centro de datos ubicados dentro o fuera de Colombia, en territorios como Europa, Estados Unidos, 
                Latinoamérica u otros territorios. Los datos personales no serán cedidos a terceros, salvo que exista una autorización previa, 
                expresa e informada de los titulares del dato o autorizados de la ley.</span></br></br>
            <span>Cualquier persona que haga parte de uno de los grupos de interés, en su condición de titular o legítimamente autorizado, 
                en relación con tratamiento de sus datos personales tiene derecho a:</span></br></br>
            <ul>
                <li><span>Ejercer su derecho de habeas data consistente en conocer, actualizar, 
                    rectificar su información de carácter personal. También podrá oponerse y cancelar sus datos e información personal en aquellos casos en que proceda.</span></li></br>
                <li><span>Evidenciar la existencia del consentimiento otorgado, salvo que exista autorización 
                    legal para el tratamiento o el mismo se realice en el marco de un contrato o convenio.</span></li></br>
                <li><span>Ejercer las acciones que la ley reconoce en materia de protección de datos 
                    personales y habeas data.</span></li></br>
            </ul></br>
            <span>Para el ejercicio del habeas data, el titular del dato personal o quien demuestre un legítimo interés conforme lo señalado en 
                la normatividad vigente, podrá hacerlo a través de los siguientes medios o dirigiendo una comunicación a la siguiente dirección física:</span></br></br>
            <ul>
                <li><span>Dirección: Carrera 64#67b-35</span></li></br>
                <li><span>Correo electrónico: </span><span>contabilidad@tcc.com.co; </span><a href="mailto:cumplimiento@tcc.com.co"><span>cumplimiento@tcc.com.co</span></a></li></br>
                <li><span>Página web: </span><a href="http://www.falkon.com.co" target="_blank"><span>www.falkon.com.co</span></a><span> opción “Contáctenos”</span></li></br>
            </ul></br>
            <span>Quien ejerza el habeas data deberá suministrar con precisión los datos de contacto solicitados para efectos de tramitar, atender y 
                responder su solicitud y desplegar las cargas para el ejercicio de sus derechos. Recibida la solicitud de ejercicio de habeas data, el responsable dará respuesta 
                en el término legal de 15 días hábiles, el cual podrá ser prorrogado por 8 días adicionales, previa comunicación a quien ha ejercido este derecho.</span></br></br>
            <span>La política de protección de datos personales en el portal web del responsable del tratamiento aquí identificado se podrá 
                encontrar en la página web </span><a href="http://www.falkon.com.co" target="_blank"><span>www.falkon.com.co</span></a><span>.</span></br></br>
            <span>La suscripción de este documento mediante un mensaje de datos electrónico es una manifestación previa, expresa e informada mediante 
                la cual la persona titular que ha suministrado sus datos personales autoriza a la sociedad identificada en este aviso de privacidad como responsable del 
                tratamiento para las finalidades y tratamientos informados mientras estas se mantengan vigentes en la operación empresarial del responsable.</span></br></br>
        `,
        noAcceptanceText: `
            Para continuar, es necesario que aceptes nuestros términos y condiciones, asi como el tratamiento de datos personales.
            Si tienes alguna duda o necesitas más información no dudes en contactarnos.
        `,
        acceptTerms: false,
        acceptDataPolicyTreatment: false,
        endScroll: false,
        userAgent: window.navigator.userAgent,
        operativeSistem: 'desconocido',
        date: "",
        showNoAcceptance: false,
    }),
    methods: {
      toggleModal (value) {
        this.$emit('input', value)
      },
      async AcceptAllPolices(){
        this.date = new moment().format("YYYY-MM-DD hh:mm a");
        this.acceptDataPolicyTreatment = true;
        
        let data = {
            acceptTermsAndConditions: this.acceptTerms,
            acceptDataPolicyTreatment: this.acceptDataPolicyTreatment,
            date: this.date,
            operativeSistem: this.operativeSistem,
        };

        if(!this.isLoggedIn){
            this.$emit('update-terms', true);
            this.toggleModal(false);
        }
        else {
            data.email = this.user.email;
            let response = await post("/channel/api/user-terms-policy", data);

            if(response.status == 200 && response.success){
                this.toggleModal(false);
            }
        }
      },
      DeclineAllPolices(){
        /* this.acceptTerms= false;
        this.acceptDataPolicyTreatment= false;
        this.$emit('update-terms', false);
        this.toggleModal(false);
        this.endScroll = false; */
        this.showNoAcceptance = true;
      },
      handleScroll(e){
        var contenedor = e.target;
        var scrollPosition = contenedor.scrollTop + contenedor.clientHeight;
        var threshold = contenedor.scrollHeight * 0.85; 
        
        if (scrollPosition >= threshold && this.acceptTerms) {
            this.endScroll = true;
        }
      },
      closeNoAcceptance(){
        this.showNoAcceptance = false;
      }
    },    
    props: ['value', 'terms']
  }
</script>

<style lang="scss" scoped>
    @import "../../scss/variables.scss";
    
    .title-modal {
        font-weight: 500;
        padding-left: 15px;
        
        @media screen and (max-width: 767px){
            white-space: nowrap; /* Evita el salto de línea */
            overflow: hidden; /* Oculta el texto que sobrepase el contenedor */
            text-overflow: ellipsis; /* Agrega puntos suspensivos */
            width: 90%;
            display: block;
        }
    }
    #container-modal-body {
        max-height: 500px;
        overflow-y: auto;
        color: $c8;

        ul {
            li {
                &::marker {
                    color: $c4;
                }
            }
        }

        .btn-terms {
            border: 2px solid $c3;
            background-color: $c2 !important;
            color: $c3 !important;

            &[disabled] {
                background-color: $c3 !important;
                color: $c2 !important;
            }
        }
    }
    .card-actions-modal {
        border-top: 2px solid #ccc;

        .btn-controlls {
            border: 2px solid $c3;
            &[disabled] {
                border: 2px solid $c10;
            } 
            &:focus {
                background-color: $c3;
                color: $c2 !important;
            }
        }
    }

    .toolbar-no-acceptance-modal {
        position: relative;

        .title-no-acceptance-modal {
            color: $c8;
            font-family: 'Lexend Exa', sans-serif;
            font-weight: 600;
            font-size: 15px;
        }

        
        .btn-close-noacceptance {
            position: absolute;
            right: -15px;
            top: -15px;
            background-color: $c2;
            border-radius: 50%;
            padding: 3px;
        }
    }
    .no-acceptance-text {
        color: $c8 !important;
        font-family: 'Lexend Exa', sans-serif;
        letter-spacing: -1px;
        font-size: 13px;
        font-weight: 500;
        line-height: 19px;
    }
</style>